import { Util } from './_util.js';
import { gsap, ScrollTrigger } from 'gsap/all';

import Views from './views/index.js';
import Sliders from './sliders.js';
import Transitions from './transitions.js';

const App = {
  sayHelloTest: function(fName) {
    console.log(`Hello, ${fName}`);
  },
  init: function() {
    $('#tribe-events-pg-template').attr('data-barba', 'container');
    $('#tribe-events-pg-template').attr('data-barba-namespace', 'singleEvent');

    const templateDirectory = $('#template-directory').text();
    window.vin65remote.cart.init('https://shop.baileyana.com', 0);
    window.vin65remote.product.addToCartForm('https://shop.baileyana.com');
    window.vin65remote.usertools.loginWidget('https://shop.baileyana.com');

    gsap.registerPlugin(ScrollTrigger);

    /* $('.nav-item').on('click', function() {
      $('.nav-item').removeClass('active');
      $(this).addClass('active');
    }); */

    this.mobileMenuStyles();
    this.headerStyles();
    this.getPageJS();

    //TODO: break them out for each specific page
    Sliders.init();

    Transitions.common();

    this.shopAllBaileyana();

    // $('#gform_1').on('submit', function(e){
    //   e.preventDefault();
    // })
  },
  mobileMenuStyles: function() {
    $('#mobile-menu-toggle').on('click', function() {
      var wasOpen = $(this).hasClass('open');
      if (wasOpen) {
        $('.mobile-navigation').removeClass('open');
        $('.header').removeClass('open');
        $(this).removeClass('open');
        $('body').removeClass('navigation-open');
      } else {
        $('.mobile-navigation').addClass('open');
        $(this).addClass('open');
        $('body').addClass('navigation-open');
        $('header').addClass('open');
      }
    });
  },
  headerStyles: function() {
    window.addEventListener('scroll', function() {
      var height = $(window).scrollTop();
      if (height > 330) {
        $('.hero-navigation').addClass('affix');
        $('.nav-dropdowns-wrapper').addClass('affix');
        $('.homepage-navigation').addClass('affix-mobile');
      } else {
        $('.hero-navigation').removeClass('affix');
        $('.nav-dropdowns-wrapper').removeClass('affix');
        $('.homepage-navigation').removeClass('affix-mobile');
      }
      if (height > 400) {
        $('.nav-dropdowns-wrapper').addClass('affix-2');
      } else {
        $('.nav-dropdowns-wrapper').removeClass('affix-2');
      }
      if (height > 800) {
        $('.homepage-navigation').addClass('affix');
      } else {
        $('.homepage-navigation').removeClass('affix');
      }
    });
  },
  getPageJS: function() {
    let page =
      $('body')
        .find('main')
        .data('barba-namespace') || 'default';
    let activePage = Views[page];

    activePage.init();
  },
  shopAllBaileyana: function() {
    if (!document.contains(document.querySelector('.footer.shop-baileyana'))) return false;

    let $pdp = $('#wine-pdp article');

    $pdp.removeClass('tangent truemyth true-myth zocker brand-tangent brand-truemyth brand-zocker');
    $pdp.addClass('baileyana brand-baileyana');

    if (document.contains(document.querySelector('.hero-navigation'))) {
      $('.hero-navigation').addClass('negate-large');
    }
  },
};
export default App;
